<template>
  <div v-if="deliveryTimeText" class="tp-text-body">
    {{ deliveryTimeText }}
  </div>
</template>

<script>
export default {
  name: 'DeliveryTimeText',
  props: {
    orderDetails: {
      type: Object,
      required: true,
    },
    orderStatus: {
      type: String,
      required: true,
    },
  },
  computed: {
    orderActive() {
      const order = this.orderDetails;
      return order && order.status === 'active';
    },
    orderInProgress() {
      const order = this.orderDetails;
      return order && this.orderActive && order.accepted_at;
    },
    orderCompleted() {
      const order = this.orderDetails;
      return order && order.status === 'closed';
    },
    deliveryTimeText() {
      const order = this.orderDetails;
      if (!order) return '';

      // If order failed, show failure description
      if (this.orderStatus === 'failed') {
        return this.$t('screens.order.orderFailedDescription');
      }

      // If order is closed/completed, show ready for pickup
      if (this.orderCompleted) {
        return this.$t('screens.order.pickup.orderStatusDelivered', {
          orderId: order.order_id,
        });
      }

      // If we have wait_minutes, show pickup time
      if (order.wait_minutes && order.accepted_at) {
        const acceptedAt = new Date(order.accepted_at);
        const pickupTime = new Date(
          acceptedAt.getTime() + order.wait_minutes * 60 * 1000
        );
        const timeString = pickupTime.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        });
        return this.$t('screens.order.pickUpTime') + ` - ${timeString}`;
      }

      // If order is active but no wait_minutes set yet
      if (this.orderActive) {
        return this.$t('screens.order.pickupTimeWillBeUpdated');
      }

      // If order is preparing but no wait_minutes
      if (this.orderInProgress) {
        return this.$t('screens.order.pickupTimeWillBeUpdated');
      }

      return '';
    },
  },
};
</script>
